module.exports = __webpack_public_path__ + "img/8.6a65c290.png";